import { aggregateStatusSummaries, formatCompactStatusSummary } from "../activity-evals/instance/status.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/calendar/ServicePeriodCalendarDayCell.tsx
var MAX_BARS = 4;
/** Full literal class strings — Tailwind must see them unconcatenated. */
var BAR_CLASSES = {
	caution: "bg-caution",
	critical: "bg-critical",
	info: "bg-info",
	main: "bg-main",
	neutral: "bg-neutral",
	positive: "bg-positive"
};
function ServicePeriodCalendarDayCell({ segments }) {
	if (!segments.length) return null;
	const visible = segments.slice(0, MAX_BARS);
	const overflow = segments.length - visible.length;
	const statusSummary = aggregateStatusSummaries(segments.map((seg) => seg.event.data.statusSummary).filter((summary) => Boolean(summary)));
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-xxs mt-xxs flex flex-col",
		children: [
			visible.map((seg) => /* @__PURE__ */ jsx("div", { className: `h-xxs w-full rounded-full ${BAR_CLASSES[seg.event.variant]}${seg.event.appearance === "dashed" ? " opacity-70" : ""}` }, `${seg.event.key}:${seg.dayStartMs}`)),
			overflow > 0 && /* @__PURE__ */ jsxs("div", {
				className: "text-color-subtle text-xs",
				children: ["+", overflow]
			}),
			statusSummary && statusSummary.total > 0 && /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle text-xs",
				children: formatCompactStatusSummary(statusSummary)
			})
		]
	});
}
//#endregion
export { ServicePeriodCalendarDayCell };

//# sourceMappingURL=ServicePeriodCalendarDayCell.js.map